/**
 * Resolve an imported image to a URL usable as an `<img src>`.
 *
 * Bundlers disagree on what an image import evaluates to: Vite hands back the
 * URL as a string, while Next's image loader hands back a `StaticImageData`
 * object. Passing that object straight to `src` renders `[object Object]` and
 * the image breaks, which is why this has to be normalised at every use.
 */
export function assetUrl(asset: unknown): string {
  if (typeof asset === 'string') {
    return asset;
  }

  if (asset && typeof asset === 'object' && 'src' in asset) {
    const { src } = asset as { src: unknown };
    if (typeof src === 'string') {
      return src;
    }
  }

  return '';
}
